import React, { useEffect} from "react";
import "./Loader.scss";

// function Loader() {
//   return (
//     <div className='loader__page'>
//       <div class="wrapper">
//         <div class="loader-outer">
//           <div class="loader-inner">
//             <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
//           </div>
//         </div>
//         <h1>
//           <span>LOADING</span>
//         </h1>
//       </div>
//     </div>
//   );
// }

function Loader() {

  useEffect(() => {
    const preloader = document.querySelector(".preloader");
    const preloader_content = document.querySelector(".preloader_content");
    const preloader_el = document.querySelector(".preloader_el");
    const preloader_pixala = document.querySelector(".preloader_pixala div");
    preloader_content.style.opacity = 1;
    preloader_el.style.transform = "translateX(0)";
    preloader_pixala.style.transform = "translateX(0)";
    preloader.addEventListener("animationend", () => {
      preloader.style.display = "none";
    });
  }, []);

  return (
    <div className="preloader">
      <div className="preloader_content">
        <div className="preloader_el">
          <div>Pixala </div>
        </div>
        <div className="preloader_pixala">
          <div> -Clikd</div>
        </div>
      </div>
    </div>
  );
}

export default Loader;
